<template>
  <div>
    <el-dialog
      title="Профили полномочий"
      :visible.sync="show"
      width="80%"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      :show-close="false"
    >
      <template slot="title">
        <div style="display: flex; justify-content: space-between">
          <div>
            Профили полномочий
          </div>
          <el-button
            type=""
            size="mini"
            icon="fas fa-plus"
            @click="createProfile"
          >
            Добавить профиль
          </el-button>
        </div>
      </template>




      <div v-loading="loading">
        <el-card
          v-for="profile in profiles"
          :key="profile.id"
          style="margin-bottom: 10px"
        >

          <cascading-permissions-profiles-edit-form
            :permissions="permissions"
            :profile="profile"
            @deleted="loadProfiles"
          ></cascading-permissions-profiles-edit-form>

        </el-card>

      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="show=false">Закрыть</el-button>
      </span>
    </el-dialog>

    <span ref="wrapper">
      <slot name="reference"></slot>
    </span>
  </div>
</template>

<script>

import { off, on } from "element-ui/src/utils/dom";
import ClickToEdit from "@/components/ClickToEdit.vue";
import CascadingPermissionsProfilesEditForm
  from "@/modules/cascading/components/permissionsProfile/CascadingPermissionsProfilesEditForm.vue";

export default {
  name: "CascadingPermissionsProfilesEditModal",
  components: { CascadingPermissionsProfilesEditForm, ClickToEdit},
  props: {},

  data() {
    return {
      loading: false,
      show: false,
      permissions: [],
      profiles: [],
    }
  },
  mounted() {
    if (this.$refs.wrapper.children) {
      on(this.$refs.wrapper.children[0], 'click', this.showModal);
    }
  },
  beforeDestroy() {
    if (this.$refs.wrapper.children) {
      off(this.$refs.wrapper.children[0], 'click', this.showModal);
    }
  },
  watch: {},
  methods: {
    showModal() {
      this.show = true;
      this.loadPermissions();
      this.loadProfiles();
    },

    loadPermissions() {
      this.loading = true;
      this.$api.cascading.getPermissionsList()
        .then(data => {
          this.permissions = data.permissions;
        })
        .finally(() => {
          this.loading = false;
        })
    },

    loadProfiles() {
      this.loading = true;
      this.$api.cascading.getPermissionsProfiles()
        .then(data => {
          this.profiles = data.profiles;
        })
        .finally(() => {
          this.loading = false;
        })
    },

    createProfile() {
      this.loading = true;
      this.$api.cascading.createPermissionsProfile()
        .finally(() => {
          this.loadProfiles();
        })
    },


  },


}
</script>
